import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';

import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
    AOS.refresh(); // optional: refresh if content changes dynamically
  }, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingBottom: "50px",
				}}
			>
				<div 
					className="container"
					
				>
					
					<div className="row">

						<div className="col-md-12 mt-5 text-center">
							<h6
								className="main-section-title"
							>
								OUR SERVICES
							</h6>
							<p className="text-dim pb-4" style={{maxWidth: '900px', margin: '0 auto'}}>
								Established with a commitment to professionalism, safety and sustainability, Jenga Construction Ltd delivers commercial and residential building construction, infrastructure development, structural rehabilitation and routine maintenance across the region.
							</p>
						</div>

						<OneService
							image={banner3}
							title="Building Construction"
							description="Commercial buildings, residential housing, office blocks and warehouses delivered with precision, safety and efficiency."
							navToLink={{ item: "services", subItem: "building-construction" }}
						/>

						<OneService
							image={banner2}
							title="Civil Engineering Works"
							description="Road construction & rehabilitation, drainage systems, bridge works, culverts and earthworks."
							navToLink={{ item: "services", subItem: "civil-engineering" }}
						/>

						<OneService
							image={banner5}
							title="Rehabilitation & Renovation"
							description="Structural repairs, building rehabilitation, facility upgrades and finishes & remodelling."
							navToLink={{ item: "services", subItem: "rehabilitation" }}
						/>

						<OneService
							image={banner6}
							title="Routine Maintenance"
							description="Building and road maintenance, site improvements, landscaping and compound work for long-term asset value."
							navToLink={{ item: "services", subItem: "maintenance" }}
						/>


						{appContext.navItem !== 'services' && (
						<div className="col-12 text-center mt-5">
							<button className="btn btn-primary btn-padded rounded-pill" onClick={() => appContext.navTo({ item: 'services' })}>
								View All Services <FaArrowCircleRight size={18} style={{marginLeft: '8px'}} />
							</button>
						</div>
					)}

					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
